import { Radio, Stack } from '@mantine/core';

interface RadioButtonGroupProps {
  label?: string;
  items?: { id: string; label: string }[];
  value?: string;
  onChange?: (value: string) => void;
  description?: string;
  isDisabled?: boolean;
}

export const RadioButtonGroup = ({
  label,
  items = [],
  value,
  onChange,
  description,
  isDisabled,
}: RadioButtonGroupProps) => {
  return (
    <Radio.Group
      value={value}
      label={label}
      description={description}
      onChange={onChange}
    >
      <Stack gap="xs" mt="xs">
        {items.map((item: { id: string; label: string }) => (
          <Radio
            key={item.id}
            value={item.id}
            label={item.label}
            disabled={isDisabled}
          />
        ))}
      </Stack>
    </Radio.Group>
  );
};
